export default __webpack_public_path__ + "svg/why/motor.svg?df0bc186";